// Cookies:-
/** @deprecated This relies on OBS functionality */
export const COOKIE_FOR_SESSION_NAME = 'obs-session';
export const COOKIE_FOR_MOBILE_NAME = 'mobile';
export const COOKIE_FOR_POSSIBLE_EXISTING_CUSTOMER_NAME = 'sgCustomer';
export const COOKIE_FOR_COUNTDOWN_TIMESTAMP = 'lastSyncedAutoLogoutTimestampRefresh';
export const PREFERRED_LOCALE_COOKIE_NAME = 'preferred_locale';
export const REDIRECT_TARGET_COOKIE_NAME = 'redirect_target';
export const REDIRECT_ORIGIN_COOKIE_NAME = 'redirect_origin';
export const IR_CLICK_ID_COOKIE_NAME = 'irclickid';
export const RAF_ID_COOKIE_NAME = 'raf';
// Local Storage:-
export const AUTH_TOKEN_KEY = 'auth_token';
export const UC_USER_INTERACTION_KEY = 'uc_user_interaction';
export const LOGIN_REFERRER_KEY = 'obs-login-referrer';
export const AUTH_TIME_DIFF_KEY = 'auth_time_diff';
export const AUTH_CONFIG_DONE_KEY = 'auth_config_done';
// Session Storage:-
//# sourceMappingURL=storage.js.map